import * as PubSub from 'pubsub-js'

export type EventPayload = {
  room_id: number
  source: string
}

const message = 'room_change'

export const publish = (payload: EventPayload) : void => {
  PubSub.publish(message, payload)
}

export const subscribe = (callback: (payload: EventPayload) => void) : string => {
  return PubSub.subscribe(message, (msg, data) => {
    callback(data)
  })
}

export const unsubscribe = (token : string) : void => {
  PubSub.unsubscribe(token)
}
